import { DealStatusCatalog, DealStatusId } from './types';

export const SLICE_KEY = 'clientBase'; // если нужен локальный slice — можно переиспользовать

export const DEFAULT_PAGE_SIZE = 25;

export const STATUS_ORDER: DealStatusId[] = [
    'contact',
    'need',
    'presentation',
    'selection',
    'objections',
    'closing',
    'waiting_object',
    'waiting_money',
    'closed_success',
    'failed',
];

// statusCatalog.ts
export const CLIENT_DEAL_STATUSES: DealStatusCatalog = [
    { id: 7590845760000001, code: "contact", name: "Контакт",          color: "#4B9CE2" },
    { id: 7590845760000002, code: "need",    name: "Выявление потребности", color: "#4B9CE2" },
    { id: 7590845760000003, code: "presentation", name: "Презентация продукта", color: "#4B9CE2" },
    { id: 7590845760000004, code: "selection",    name: "Подбор",      color: "#4B9CE2" },
    { id: 7590845760000005, code: "objections",   name: "Отработка возражений", color: "#4B9CE2" },
    { id: 7590845760000006, code: "closing",      name: "Закрытие",    color: "#4B9CE2" },
    { id: 7590845760000007, code: "waiting_object", name: "Ждём объект", color: "#4B9CE2" },
    { id: 7590845760000008, code: "waiting_money", name: "Ждём деньги", color: "#4B9CE2" },
    { id: 7590845760000009, code: "closed_success", name: "Успех",     color: "#4B9CE2" },
    { id: 7590845760000010, code: "failed",        name: "Провал",     color: "#FF3B30" },
];


export const STATUS_CATALOG_DEFAULT: DealStatusCatalog = [
    { id: 'contact',         name: 'Установление контакта', isFinal: false, color: '#4B9CE2' },
    { id: 'need',            name: 'Выявление потребности',  isFinal: false, color: '#4B9CE2' },
    { id: 'presentation',    name: 'Презентация преимуществ продукта', isFinal: false, color: '#4B9CE2' },
    { id: 'selection',       name: 'Подбор',                 isFinal: false, color: '#4B9CE2' },
    { id: 'objections',      name: 'Отработка возражений',   isFinal: false, color: '#4B9CE2' },
    { id: 'closing',         name: 'Закрытие сделки',        isFinal: false, color: '#4B9CE2' },
    { id: 'waiting_object',  name: 'Ждём объект',            isFinal: false, color: '#FFB800' },
    { id: 'waiting_money',   name: 'Ждёт денег',             isFinal: false, color: '#FFB800' },
    { id: 'closed_success',  name: 'Сделка закрыта',         isFinal: true,  color: '#34C759', requiresSelection: true },
    { id: 'failed',          name: 'Провал',                 isFinal: true,  color: '#FF3B30' },
];

export const SEARCH_PLACEHOLDER = 'Поиск по имени, телефону, email, запросу…';

export const EMPTY_STATE_TEXT = 'Клиенты пока не добавлены';
